import type { FeatureModule } from '../../../types';
import { featureList } from '../../helpers';
import { DOMAINS_FEATURE_GROUP } from './group';
import { DOMAINS_EMAIL_FEATURES, DOMAINS_EMAIL_FEATURE_GROUP } from './email';
import { DOMAINS_WEB_FEATURES, DOMAINS_WEB_FEATURE_GROUP } from './web';

export { DOMAINS_FEATURE_GROUP } from './group';
export { DOMAINS_EMAIL_FEATURES, DOMAINS_EMAIL_FEATURE_GROUP } from './email';
export { DOMAINS_WEB_FEATURES, DOMAINS_WEB_FEATURE_GROUP } from './web';

export const DOMAINS_MODULE: FeatureModule = {
  product: 'account',
  groups: [DOMAINS_FEATURE_GROUP, DOMAINS_EMAIL_FEATURE_GROUP, DOMAINS_WEB_FEATURE_GROUP],
  features: [...featureList(DOMAINS_EMAIL_FEATURES), ...featureList(DOMAINS_WEB_FEATURES)],
};
